import React, { FC, useState } from 'react'
import './BankUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import employeeService from 'Services/employeeService'

interface propsType {
  toggleModal: () => void
}

export type bankUpdate = {
  bank: string
  accountNumber: string
}

const schema = yup.object().shape({
  bank: yup.string().required('Field is required'),
  accountNumber: yup.string().required('Field is required'),
})

const BankUpdate: FC<propsType> = ({ toggleModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<bankUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const submitNewUserInformation = handleSubmit(async (data: bankUpdate) => {
    // await employeeService.createNew(data).then(
    //   () => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: 'Pension Details updated successfully',
    //       show: true,
    //       title: 'Success',
    //       type: 'success',
    //     })
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 200)
    //   },
    //   (error: { response: { data: { error: string } } }) => {
    //     setRequest(false)
    //     toggleModal()
    //     showAlert({
    //       message: error.response.data.error,
    //       show: true,
    //       title: 'Error',
    //       type: 'error',
    //     })
    //   },
    // )
  })
  return (
    <div className='bank-update'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='Bank'>Bank</label>
          <select id='bank' defaultValue='' className='form-control' {...register('bank')}>
            <option disabled value=''>
              --Select Bank--
            </option>
            <option value='uba'>United Bank of Africa</option>
            <option value='zenith'>Zenith Bank Plc</option>
            <option value='union'>Union Bank</option>
          </select>
          {errors.bank && <div className='text-danger'>{errors.bank.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Account Number</label>
          <input
            placeholder='Account Number'
            type='text'
            id='accountNumber'
            className='form-control'
            {...register('accountNumber')}
          />
          {errors.accountNumber && <div className='text-danger'>{errors.accountNumber.message}</div>}
        </div>

        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default BankUpdate
